import { type Site, datadogRum } from '@datadog/browser-rum';
import { env } from '@/env';
import { jucyInsights } from './jucyInsights';

function initDatadogRum() {
    if (typeof window === 'undefined' || !env.NEXT_PUBLIC_DD_APP_ID || !env.NEXT_PUBLIC_DD_CLIENT_TOKEN || !env.NEXT_PUBLIC_DD_SITE) {
        return;
    }

    datadogRum.init({
        applicationId: env.NEXT_PUBLIC_DD_APP_ID,
        clientToken: env.NEXT_PUBLIC_DD_CLIENT_TOKEN,
        site: env.NEXT_PUBLIC_DD_SITE as Site,
        service: env.NEXT_PUBLIC_DD_SERVICE,
        env: env.NEXT_PUBLIC_ENV,
        version: env.NEXT_PUBLIC_VERSION || '0',
        sessionSampleRate: 0,
        sessionReplaySampleRate: 0,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        enableExperimentalFeatures: ['feature_flags'],
        defaultPrivacyLevel: 'allow',
        allowedTracingUrls: [(url) => jucyInsights.shouldTraceUrl(url)],
        proxy: (options) => `https://${jucyInsights.resolveInsightsDomain(window.location.href)}/ingest${options.path}?${options.parameters}`,
    });
}
initDatadogRum();
